import { datadogRum } from '@datadog/browser-rum';
import { TrashIcon } from '@heroicons/react/24/outline';
import { Icon } from '@stereograph/teia-system-design/components/Icon';
import { IconButton } from '@stereograph/teia-system-design/components/IconButton';
import { usePluginTranslation } from '@translation';
import { useState } from 'react';
import { useAnomalyDocumentContext } from '../../context/AnomalyDocumentContext';
import { AnomalyDocumentDeleteModal } from './AnomalyDocumentDeletionModal';

export const AnomalyDocumentCardDelete = () => {
  const { anomalyDocument } = useAnomalyDocumentContext();
  const { t } = usePluginTranslation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const onOpenDeleteModal = () => {
    setIsDeleteModalOpen(true);
    datadogRum.addAction('tvp.anomaly.document.delete_modal', {
      isOpen: true,
    });
  };

  const onCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    datadogRum.addAction('tvp.anomaly.document.delete_modal', {
      isOpen: false,
    });
  };

  return (
    <>
      <IconButton
        onClick={onOpenDeleteModal}
        aria-label={t('anomaly_plugin.document.download_label')}
        iconOnly
      >
        <Icon component={TrashIcon} fontSize="small" />
      </IconButton>
      <AnomalyDocumentDeleteModal
        isModalOpen={isDeleteModalOpen}
        onClose={onCloseDeleteModal}
        document={anomalyDocument}
      />
    </>
  );
};
